module.exports = __webpack_public_path__ + "img/reward_default_01.6f676475.png";